import styled from 'styled-components';
import { default as SlickSlider } from 'react-slick';

export const SliderStyled = styled(SlickSlider)`
	position: relative;
`;
